// css
import "./Footer.css";
// assets
import logo from "assets/Images/icons/newLogo1.png";
import fbIcon from "assets/Images/icons/facebook.svg";
// import twitterIcon from ".assets/Images/icons/twitter.svg";
import instaIcon from "assets/Images/icons/insta.svg";
// import paypalImg from "assets/Images/icons/paypal.svg";
// import amexImg from "assets/Images/icons/amex.svg";
// import payCardImg from "assets/Images/icons/pay.svg";
// import visaImg from "assets/Images/icons/visa.svg";
// import applePayImg from "assets/Images/icons/apple-pay.svg";
import newsletterImg from "assets/Images/icons/newsletter.svg";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="web-footer">
      <div className="footer-container">
        <div className="footer-row">
          <div className="footer-col-1">
            <div className="footer-logo-box">
              <img src={logo} alt="Cyan" />
            </div>
            <p className="base-line-footer">Booking Beyond Imagination.</p>
            <p className="base-line-text">Book Boats, Create events, and plan your holidays using the most innovative all-around booking system ever seen.</p>
            {/* <div className="d-flex mt-4 justify-content-lg-start justify-content-center align-items-center ft_payment-cards-wrapper">
              <div className="ft-pay-card">
                <img src={amexImg} alt="amex" />
              </div>
              <div className="ft-pay-card">
                <img src={applePayImg} alt="apple-pay" />
              </div>
              <div className="ft-pay-card">
                <img src={payCardImg} alt="pay" />
              </div>
              <div className="ft-pay-card paypal-c">
                <img src={paypalImg} alt="paypal" />
              </div>
              <div className="ft-pay-card">
                <img src={visaImg} alt="visa" />
              </div>
            </div> */}
          </div>
          <div className="footer-col-2">
            <div className="footer-sm-col">
              <div className="footer-nav-wrapper">
                <div className="footer-nav-col">
                  <h5 className="footer-nav-title">Main Pages</h5>
                  <div className="nav-li">
                    <NavLink exact to="/">
                      Home
                    </NavLink>
                  </div>
                  {/* <div className="nav-li">
                    <NavLink exact to="/events">
                      Events
                    </NavLink>
                  </div>
                  <div className="nav-li">
                    <NavLink exact to="/experience">
                    Experience
                    </NavLink>
                  </div>
            */}
                  <div className="nav-li">
                    <NavLink exact to="/about">
                      About
                    </NavLink>
                  </div>
                </div>
                <div className="footer-nav-col">
                  <h5 className="footer-nav-title">Support</h5>
                  <div className="nav-li"> <NavLink exact to="/contact">
                    Contact us
                  </NavLink>   </div>
                  <div className="nav-li"><NavLink exact to="/contact">
                    Terms & Services
                  </NavLink>   </div>
                </div>
              </div>
              <div className="news-letter-top-text">
                <p>Sign up to our newsletter and be the first to know about our newest trips and offers.</p>
              </div>
              <form action="" onSubmit={(e) => { e.preventDefault() }} className="d-flex w-100 justify-content-between align-items-center newsletter-wrapper">

                <input type="text" placeholder="Enter your e-mail" />
                <button className="d-flex justify-content-center align-items-center"><img src={newsletterImg} alt="" /></button>
              </form>
            </div>
          </div>
          <div className="footer-col-3">
            <div className="footer-sm-col-right">
              <h4>Follow Us</h4>
              <div className="footer-socials-wraps">
                <a href="https://www.facebook.com/Cyan-115485296918323" target="_blank" rel="noopener noreferrer"><img src={fbIcon} alt="" /></a>
                {/* <a href="/" target="_blank" rel="noopener noreferrer"><img src={twitterIcon} alt="" /></a> */}
                <a href="https://www.instagram.com/thecyangroup/" target="_blank" rel="noopener noreferrer"><img src={instaIcon} alt="" /></a>
              </div>
              {/* <h4>Currency</h4>
              <div className="ft_select cursor-pointer">
                <select className="cursor-pointer">
                  <option>USD</option>
                  <option>FR</option>
                </select>
              </div> */}
              <div className="ft_button">
                <button></button>
                <button></button>
              </div>
              <div className="text-muted mt-3">
                <p>@CYAN2021 - All Right Reserved </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
